import React from 'react';
import { Box, Typography } from '@mui/material';

export interface FormSectionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  children: React.ReactNode;
  /** Sets data-tour on the section wrapper for modal/page tours. */
  tourId?: string;
}

export function FormSection({ icon, title, description, children, tourId }: FormSectionProps) {
  const ACCENT = '#2C3E2D';
  const BORDER = '1px solid #E2DDD8';

  return (
    <Box mb={3} data-tour={tourId}>
      <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
        <Box
          sx={{
            width: 28,
            height: 28,
            bgcolor: '#FAFAF8',
            border: BORDER,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: ACCENT,
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: ACCENT,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          <Typography variant="caption" sx={{ color: '#9B958F', lineHeight: 1.2 }}>
            {description}
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  );
}

export default FormSection;
